var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.10346C5.63455 2.10346 2.09565 5.64236 2.09565 10.0078C2.09565 14.3733 5.63455 17.9122 10 17.9122C14.3655 17.9122 17.9043 14.3733 17.9043 10.0078C17.9043 5.64236 14.3655 2.10346 10 2.10346ZM1 10.0078C1 5.03725 5.02944 1.00781 10 1.00781C14.9706 1.00781 19 5.03725 19 10.0078C19 14.9784 14.9706 19.0078 10 19.0078C5.02944 19.0078 1 14.9784 1 10.0078ZM9.99992 5.35099C10.3025 5.35099 10.5478 5.59626 10.5478 5.89882V6.33913C10.5478 6.64169 10.3025 6.88696 9.99992 6.88696C9.69737 6.88696 9.4521 6.64169 9.4521 6.33913V5.89882C9.4521 5.59626 9.69737 5.35099 9.99992 5.35099ZM9.99992 8.96504C10.3025 8.96504 10.5477 9.21031 10.5477 9.51287L10.5478 13.6784C10.5478 13.981 10.3025 14.2262 9.99992 14.2262C9.69737 14.2262 9.4521 13.981 9.4521 13.6784L9.4521 9.51287C9.4521 9.21032 9.69737 8.96504 9.99992 8.96504Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMessageIcon);
export default __webpack_public_path__ + "static/media/error-message-icon.493da81d4dc90c2fc7345d032351ac1c.svg";
export { ForwardRef as ReactComponent };